const FAQS = [
  {
    id: 'faq-grupos',
    question: '¿Cuántos estudiantes hay por grupo?',
    answer: 'Mantenemos grupos de aproximadamente 10 estudiantes por grado, lo que permite ofrecer una educación más personalizada y un seguimiento cercano.'
  },
  {
    id: 'faq-materiales',
    question: '¿Qué materiales necesita mi hijo?',
    answer: 'Trabajamos con currículo digital Edusystem, complementado con materiales educativos adicionales según necesidades.'
  },
  {
    id: 'faq-verano',
    question: '¿Ofrecen servicios durante el verano?',
    answer: 'Actualmente no contamos con programa de verano.'
  },
  {
    id: 'faq-bilingue',
    question: '¿El programa es completamente en inglés?',
    answer: 'Nuestro programa es bilingüe, integrando inglés y español.'
  },
  {
    id: 'faq-diagnosticos',
    question: '¿Solo aceptan niños con diagnósticos?',
    answer: 'No. Aceptamos estudiantes regulares y aquellos que necesiten apoyo individualizado.'
  },
  {
    id: 'faq-horario-reducido',
    question: '¿Por qué el horario es reducido?',
    answer: 'Priorizamos calidad sobre cantidad, con enfoque en aprendizaje efectivo y desarrollo integral.'
  },
  {
    id: 'faq-cuido',
    question: '¿Ofrecen cuido extendido?',
    answer: 'Actualmente no contamos con este servicio.'
  }
];

export const AdmisionFaqs = () => (
  <section className="py-20 md:py-28" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="text-center mb-12">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Preguntas Frecuentes</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
          ¿Tienes dudas?
        </h2>
      </div>

      <div className="space-y-4">
        {FAQS.map((faq) => (
          <div key={faq.id} className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border-l-4 border-[#d3b163]" data-testid={`faq-${faq.id}`}>
            <h3 className="font-semibold text-stone-900 mb-2">{faq.question}</h3>
            <p className="text-base text-stone-700 leading-relaxed">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
